import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { API_BASE_URL } from '../config/apiConfig';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setErrorMsg('');

    try {
      const response = await fetch(`${API_BASE_URL}/UserManagement/ForgotPassword`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });

      const data = await response.json();
      if (!response.ok) {
        setErrorMsg(data.message || 'Something went wrong.');
      } else {
        setMessage(data.message);
      }
    } catch (err) {
      setErrorMsg('Something went wrong. Please try again.');
    }
  };

  return (
    <>
      <Header />
      <main className="rbt-main-wrapper">
        <section className="shirt-client-login">
          <div className="login-form-wrapper">
            <div className="login-form-box">
              <h2 className="login-form-title">Forgot Password</h2>
              <p className="login-form-subtitle">
                Enter your email address to receive a temporary password.
              </p>
              <form className="login-form" onSubmit={handleSubmit}>
                <input
                  type="email"
                  className="login-input"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />

                {errorMsg && <p className="text-danger mt-2">{errorMsg}</p>}
                {message && <p className="text-success mt-2">{message}</p>}

                <button type="submit" className="login-btn">Send Reset Link</button>
              </form>
              <p className="register-cta">
                Remember your password? <a href="/login">Go back to login</a>
              </p>
            </div>
          </div>
        </section>
        <Footer />
      </main>
    </>
  );
};

export default ForgotPassword;
